import { __decorate } from "tslib";
import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { uiMapper } from "@/services/store/modules/ui/store";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {},
    methods: {},
});
let ItemIntro = class ItemIntro extends Mixins(UiMappers, DataMappers) {
};
__decorate([
    Prop()
], ItemIntro.prototype, "item", void 0);
ItemIntro = __decorate([
    Component({
        components: {},
    })
], ItemIntro);
export default ItemIntro;
